// extracted by mini-css-extract-plugin
export default {"page":"c-a_at","page_withoutPaddingTop":"c-a_au","page_withoutGap":"c-a_av","page_withMarginBottom":"c-a_aw"};